import React from "react";

const Footer = () => {
  return (
    <footer style={{ textAlign: "center", padding: "1rem", backgroundColor: "#f1f1f1", marginTop: "2rem" }}>
      <p>Music provided by <a href="https://chillhop.ffm.to/creatorcred" target="_blank" rel="noopener noreferrer" style={{ color: "#000000" }}>
      Chillhop Music</a>
      </p>
    </footer>
  );
};

export default Footer;